import type { Employee, EmployeeDTO } from '@entities/employee'
import type { PartnerOrd, PartnerOrdDTO } from '@entities/partner'
import type { PostType, PostTypeDTO } from '@entities/post'

export enum EmployeeChannelRole {
    owner = 'owner',
    employee = 'employee',
    invitee = 'invitee'
}

export interface TempChannel {
    id: number
    name: string
    username: string
    photoUrl: string
}

export interface TempChannelDTO {
    chat_id: number
    title: string
    username: string
    photo_url: string
}

export interface Channel {
    id: number
    telegramId: number
    username: string
    name: string
    membersCount: number
    photoUrl: string
    createdAt: Date
    updatedAt: Date
    owner: string
    tgRole: string
    role: EmployeeChannelRole
    timezone: string
    language: string
    country: string
    category: string
    settings?: ChannelSettings
    type: InternetRecourceType
    url: string
    visibleForPartners: boolean
    isFake: boolean
}

export interface ChannelDTO {
    id: number
    telegram_id: number
    username: string
    name: string
    members_count: number
    photo_url: string
    created_at: string
    updated_at: string
    owner: string
    role: EmployeeChannelRole
    tg_role: string
    timezone: string
    language: string
    country: string
    category: string
    settings: ChannelSettingsDTO
    type: InternetRecourceType
    url: string
    visible_for_partners: boolean
    is_fake: boolean
}

export interface ChannelSettings {
    general: {
        silenceMode: boolean
        postTypes: PostType[]
        signature: string
        tokenLinkText: string
        showSignature: boolean
    }
    employees: {
        employees: Employee[]
    }
    finance: {
        id: number
    }
    ord: PartnerOrd
}

export interface ChannelSettingsDTO {
    general: {
        silence_mode: boolean
        post_types: PostTypeDTO[]
        signature: string
        token_link_text: string
        show_signature: boolean
    }
    employees: {
        employees: EmployeeDTO[]
    }
    finance: {
        id: number
    }
    ord: PartnerOrdDTO
}

export interface ChannelStore {
    current: Nullable<Channel>
    setCurrent: (channel: Nullable<Channel>) => void
}

export enum InternetRecourceType {
    channel = 'channel',
    site = 'site'
}
